import { render, staticRenderFns } from "./EmailSend.vue?vue&type=template&id=ffd44e0e&scoped=true&"
import script from "./EmailSend.vue?vue&type=script&lang=js&"
export * from "./EmailSend.vue?vue&type=script&lang=js&"
import style0 from "./EmailSend.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./EmailSend.vue?vue&type=style&index=1&id=ffd44e0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd44e0e",
  null
  
)

export default component.exports